/* Vitality Ring PDP behaviours (template product.vitality-ring-pdp). Loaded once per page. */
(function () {
  if (window.__vrPdp) return;
  window.__vrPdp = true;
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var updaters = [];

  function bindRail(rail) {
    if (rail.__vrRail) return;
    rail.__vrRail = true;
    var bar = document.getElementById(rail.getAttribute('data-vr-rail'));
    var thumb = bar && bar.querySelector('.vr-rail-thumb');
    function update() {
      if (!thumb) return;
      var bw = bar.clientWidth, cw = rail.clientWidth, sw = rail.scrollWidth, max = sw - cw;
      if (!cw) return;
      rail.tabIndex = max > 1 ? 0 : -1;
      rail.classList.toggle('is-scrollable', max > 1);
      bar.setAttribute('data-scrollable', max > 1 ? 'true' : 'false');
      if (!bw) return;
      var tw = max > 1 ? Math.max(24, bw * cw / sw) : bw;
      var x = max > 1 ? (rail.scrollLeft / max) * (bw - tw) : 0;
      thumb.style.width = tw + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }
    rail.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
    updaters.push(update);
    update();
    bindDrag(rail);
  }

  // Desktop mouse: drag the rail sideways (touch and trackpads keep their native scrolling). A drag never triggers a click.
  function bindDrag(rail) {
    var down = false, moved = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || rail.scrollWidth - rail.clientWidth <= 1) return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) { moved = true; rail.classList.add('is-dragging'); }
      if (moved) { rail.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
      if (moved) setTimeout(function () { moved = false; }, 0);
    });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function refresh() { updaters.forEach(function (f) { f(); }); }

  // Rating to full reviews: the Wise star rating is a focusable role="button" that scrolls to the reviews on click
  // but ignores Enter and Space. Relay those keys to its click handler, then move focus to the reviews anchor.
  function bindRatingKeys() {
    $$('wise-star-rating [role="button"]').forEach(function (btn) {
      if (btn.__vrKeys) return;
      btn.__vrKeys = true;
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        btn.click();
        var anchor = document.getElementById('vr-pdp-reviews');
        if (anchor) setTimeout(function () { anchor.focus({ preventScroll: true }); }, 600);
      });
    });
  }

  // P08: "Try It Risk-Free" goes to the very top of the document (scrollY 0), without reload, so the Kaching selection and the
  // preview parameters stay. Focus then moves to the product title without scrolling. The href="#" fallback also reaches the top.
  function toTop(e) {
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var title = document.querySelector('.product-info__title');
    var done = false;
    function focusTitle() {
      if (done) return;
      done = true;
      if (!title) return;
      if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '-1');
      title.focus({ preventScroll: true });
    }
    window.scrollTo({ top: 0, left: 0, behavior: reduce ? 'auto' : 'smooth' });
    if (reduce || window.scrollY === 0) { focusTitle(); return; }
    if ('onscrollend' in window) window.addEventListener('scrollend', focusTitle, { once: true });
    setTimeout(focusTitle, 1500);
  }

  // S03 (user 2026-09-15, after copy 0.4.6): every card takes the height of the first card at the current width. A longer review is
  // clamped to whole lines and its "Read more" button opens the complete review in the card ("Read less" closes it); the other cards keep
  // their height. The complete text is always in the page; without this script the track stretches the cards and every review shows in full.
  function bindEqual(track) {
    if (track.__vrEqual) return;
    track.__vrEqual = true;
    var cards = $$('.vr-s03__card', track);
    if (cards.length < 2) return;
    var frame = 0, lastWidth = -1;
    function setOpen(card, open) {
      var more = card.querySelector('.vr-s03__more');
      card.classList.toggle('is-expanded', open);
      if (!more) return;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = more.getAttribute(open ? 'data-vr-less' : 'data-vr-more') || '';
    }
    function layout() {
      frame = 0;
      // The measurement hides every button for a moment, and a hidden button loses the focus: remember it and give it back at the end
      var focused = document.activeElement;
      track.classList.add('is-equal');
      cards.forEach(function (card) {
        var quote = card.querySelector('.vr-s03__quote'), more = card.querySelector('.vr-s03__more');
        card.style.minHeight = '';
        if (quote) { quote.classList.remove('is-clamped'); quote.style.removeProperty('-webkit-line-clamp'); }
        if (more) more.hidden = true;
      });
      var first = cards[0].getBoundingClientRect().height;
      cards.forEach(function (card, i) {
        var quote = card.querySelector('.vr-s03__quote'), more = card.querySelector('.vr-s03__more');
        if (i > 0 && quote && more) {
          if (card.getBoundingClientRect().height > first + 0.5) {
            more.hidden = false;
            if (!card.classList.contains('is-expanded')) {
              var line = parseFloat(getComputedStyle(quote).lineHeight) || 21;
              var excess = card.getBoundingClientRect().height - first;
              var lines = Math.max(1, Math.floor((quote.getBoundingClientRect().height - excess) / line + 0.01));
              quote.style.setProperty('-webkit-line-clamp', String(lines));
              quote.classList.add('is-clamped');
            }
          } else if (card.classList.contains('is-expanded')) setOpen(card, false);
        }
        card.style.minHeight = first + 'px';
      });
      if (focused && focused !== document.activeElement && track.contains(focused) && !focused.hidden) focused.focus({ preventScroll: true });
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(layout); }
    cards.forEach(function (card) {
      var more = card.querySelector('.vr-s03__more');
      if (!more) return;
      more.addEventListener('click', function () {
        var open = !card.classList.contains('is-expanded');
        setOpen(card, open);
        layout();
        if (!open) { var top = card.getBoundingClientRect().top; if (top < 0) window.scrollBy(0, top - 16); }
      });
    });
    var rail = track.parentNode;
    if (window.ResizeObserver) new ResizeObserver(function () { var w = rail.clientWidth; if (w !== lastWidth) { lastWidth = w; schedule(); } }).observe(rail);
    else window.addEventListener('resize', schedule);
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(schedule);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', schedule);
    }
    window.addEventListener('load', schedule);
    layout();
  }

  // Variant colour to gallery, for products whose media are the slides (JSON from vr-pdp-variant-media). Kaching Bundles hides the
  // theme's variant picker and only sets the hidden variant input of the product form. Impact's gallery listens on that form for
  // product:rerender (filtered slides, read from an HTML fragment) and variant:change (scroll to the variant's media), so both are sent.
  // The form is the one the Impact gallery names in its form attribute, on any theme that renders the product media.
  function bindVariantMedia() {
    var script = document.querySelector('script[data-vr-variants]');
    if (!script || script.__vrBound) return;
    var gallery = document.querySelector('product-gallery[form]');
    var formId = gallery && gallery.getAttribute('form');
    var form = formId && document.forms[formId];
    var mediaScript = document.querySelector('script[data-vr-media]');
    var idField = form && form.elements.namedItem('id');
    if (!form || !mediaScript || !idField) return;
    script.__vrBound = true;
    var variants = JSON.parse(script.textContent || '[]');
    var media = JSON.parse(mediaScript.textContent || '[]');
    var optionNames = JSON.parse(script.getAttribute('data-vr-options') || '[]');
    function find(id) {
      id = String(id);
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i];
      return null;
    }
    // Same rule as the Impact snippet: a media whose alt ends with #Option_Value is hidden when the variant has another value
    function filteredFor(variant) {
      var out = [];
      media.forEach(function (m) {
        var alt = m.alt || '';
        if (alt.indexOf('#') < 0) return;
        if (variant.featured_media && m.id === variant.featured_media.id) return;
        var group = alt.split('#').pop().split('_');
        var idx = optionNames.indexOf(group[0]);
        if (idx < 0) return;
        var wanted = group.slice(1).join('_').trim().toLowerCase();
        if (String(variant.options[idx] || '').toLowerCase() !== wanted) out.push(m.position);
      });
      return out;
    }
    var current = find(idField.value) || variants[0];
    function apply() {
      var next = find(idField.value);
      if (!next || !current || next.id === current.id) return;
      var previous = current;
      current = next;
      var fragment = document.createRange().createContextualFragment('<product-gallery form="' + formId + '" filtered-indexes="' + JSON.stringify(filteredFor(next)) + '"></product-gallery>');
      form.dispatchEvent(new CustomEvent('product:rerender', { detail: { htmlFragment: fragment, productChange: false } }));
      // The filter shows and hides slides first; the scroll to the variant's media waits two frames so a slide shown again has its place
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { formId: formId, variant: next, previousVariant: previous } }));
        });
      });
    }
    form.addEventListener('variant:change', function (e) { if (e.detail && e.detail.variant) current = find(e.detail.variant.id) || current; });
    idField.addEventListener('change', apply);
    if (window.MutationObserver) new MutationObserver(apply).observe(idField, { attributes: true, attributeFilter: ['value'] });
    ['variant-selected', 'variants-changed'].forEach(function (t) { document.addEventListener(t, function () { setTimeout(apply, 0); }, true); });
    setInterval(apply, 400);
  }

  function init() {
    bindRatingKeys();
    bindVariantMedia();
    if (!document.querySelector('wise-star-rating [role="button"]') && window.MutationObserver) {
      var wo = new MutationObserver(function () { if (document.querySelector('wise-star-rating [role="button"]')) { bindRatingKeys(); wo.disconnect(); } });
      wo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { wo.disconnect(); }, 20000);
    }
    $$('[data-vr-rail]').forEach(bindRail);
    $$('[data-vr-equal]').forEach(bindEqual);
    $$('[data-vr-top]').forEach(function (a) {
      if (a.__vrTop) return;
      a.__vrTop = true;
      a.addEventListener('click', toTop);
    });
  }

  window.addEventListener('resize', refresh);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
